import { useCurrentNetwork } from 'hooks';

const useRuleNavigation = () => {
  const network = useCurrentNetwork();

  const subPath = `/networks/${network}`;

  const ruleListURL = subPath + '/rules';
  const ruleEditURL = (id: number) => subPath + `/rules/edit/${id}`;
  const rulDetailsURL = (id: number) => subPath + `/rules/details/${id}`;
  const ruleDuplicateURL = (id: number) => subPath + `/rules/duplicate/${id}`;
  const ruleDetailsURL = (id: number) => subPath + `/rules/details/${id}`;

  return {
    ruleListURL,
    ruleEditURL,
    ruleDuplicateURL,
    ruleDetailsURL,
    rulDetailsURL,
  };
};

export default useRuleNavigation;
